module.exports = __webpack_public_path__ + "img/alcohol_free.5c497ede.svg";